import { ActionButton } from "../submit-button/submit-button.component";

interface FallBackProps {
  title: string;
  onTryAgain: () => void;
}

export function Fallback({ title, onTryAgain }: FallBackProps): JSX.Element {
  return (
    <>
      <strong className="fkc__children--title">
        {title}
      </strong>

      <ActionButton className="three-quarters-width" onClick={onTryAgain}>
        Try again
      </ActionButton>
    </>
  )
}
